import * as React from 'react';
import { SVGProps } from 'react';

const IconFolderOpenSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 20a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2h7a2 2 0 0 1 2 2v1h1.04c1.292 0 2.23 1.254 1.89 2.526l-1.87 7A1.965 1.965 0 0 1 19.172 20H4ZM9 6v2h9v1H9.433c-.883 0-1.657.604-1.889 1.474L5.534 18H4V6h5Z"
    />
  </svg>
);
export default IconFolderOpenSizeM;
